<template >
    <form id="payment-form">
        <div id="error-message" class="bg-red-500 text-white font-bold px-2 py-4 rounded-md hidden flex mb-3">
            <ExclamationCircleIcon class="h-6 w-6 text-white mr-2" aria-hidden="true" />
            <span></span>
        </div>
        <div id="link-authentication-element"></div>
        <div id="payment-element">

        </div>
        <!--        <button id="submit">Submit</button>-->
        <div class="mt-5 sm:mt-6 flex justify-end">
            <button type="button" class="rounded-md border border-transparent shadow-sm px-4 py-2 bg-gray-800
                text-base font-medium text-white hover:bg-gray-800 focus:outline-none
                focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow sm:text-sm
                disabled:opacity-50 disabled:cursor-not-allowed mx-2" @click="$emit('close')">
                Cancel
            </button>
            <button  id="submit" class="
                rounded-md border border-transparent shadow-sm px-4 py-2 bg-racing-stars-yellow
                text-base font-medium text-gray-800 hover:bg-racing-stars-yellow focus:outline-none
                focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow sm:text-sm
                disabled:opacity-50 disabled:cursor-not-allowed" :disabled="button.processing">

                Purchase
            </button>
        </div>
    </form>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import {ExclamationCircleIcon} from "@heroicons/vue/solid";

export default {
    props: {
        user: Object,
        package: Object,
    },

    emits: ['openPurchaseMenu', 'close'],

    components: {
        ExclamationCircleIcon
    },

    setup(props, { emit }) {
        const api = ref('')
        const button = ref('')
        const form = ref('')


        onMounted((selectedTokenPackage) => {
            button.processing = false;
            const loader = 'auto';
            console.log( props.package)
            axios.post(route('api.pay'), {
                amount: props.package.price,

            }).then(response => {
                    api.value = response.data
                    const options = {
                        clientSecret: api.value.client_secret,
                        // Fully customizable with appearance API.
                        appearance: {/*...*/},
                        loader: loader
                    };

                    const elements = stripe.elements(options);
                    const linkAuthenticationElement = elements.create("linkAuthentication", {
                        defaultValues:
                            {
                                email: props.user.email,

                            }
                    });
                    const paymentElement = elements.create('payment', {
                        defaultValues: {
                            billingDetails: {
                                postcode: props.user.postcode,
                            },
                        },
                    });
                    linkAuthenticationElement.mount("#link-authentication-element");
                    paymentElement.mount("#payment-element");

                    const form = document.getElementById('payment-form');

                    form.addEventListener('submit', async (event) => {
                        button.processing = true;
                        event.preventDefault();

                        const {error} = await stripe.confirmPayment({
                            //`Elements` instance that was used to create the Payment Element
                            elements,
                            //https://stripe.com/docs/js/payment_intents/confirm_payment#confirm_payment_intent-options-redirect
                            confirmParams: {
                                return_url: window.location.origin +'/api/pay/success',
                            },
                        });

                        if (error) {
                            button.processing = false;
                            // This point will only be reached if there is an immediate error when
                            // confirming the payment. Show error to your customer (for example, payment
                            // details incomplete)

                            const messageContainer = document.querySelector('#error-message');
                            messageContainer.classList.remove('hidden');
                            document.querySelector('#error-message span').textContent = error.message;
                        } else {
                            // Your customer will be redirected to your `return_url`. For some payment
                            // methods like iDEAL, your customer will be redirected to an intermediate
                            // site first to authorize the payment, then redirected to the `return_url`.
                        }
                    });
                }
            );





        })

        return {
            api,
            form,
            button
        }

    }
}
</script>
